<c-container class="mt-5">

  <h2>Payout Rules</h2>

  @if (game) {
    <app-payout-rules [gameData]="game"></app-payout-rules>
  }

</c-container>
